
import React, { useState } from "react";
import { Link } from "react-router-dom";
import headerLogo from "../assets/CnVLogoHeader.svg";

const MainNavbar = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const closeMenu = () => setMenuOpen(false);

    return (
        <nav className="main-navbar">
            <button
                className="hamburger-button"
                type="button"
                aria-label={menuOpen ? "Close menu" : "Open menu"}
                aria-expanded={menuOpen}
                aria-controls="main-navigation"
                onClick={() => setMenuOpen(!menuOpen)}
            >
                <span></span>
                <span></span>
                <span></span>
            </button>

            <Link to="/" className="game-logo" onClick={closeMenu}>
                <img src={headerLogo} alt="Conquest & Virtue" />
            </Link>

            <Link
                to="/login"
                className="account-icon"
                aria-label="Log in"
                onClick={closeMenu}
            >
                <span className="account-head"></span>
                <span className="account-body"></span>
            </Link>

            <div
                id="main-navigation"
                className={`main-navigation ${menuOpen ? "menu-open" : ""}`}
            >
                <div className="game-nav-links">
                    <Link to="/" onClick={closeMenu}>Overview</Link>
                    <Link to="/news" onClick={closeMenu}>News</Link>
                    <Link to="/media" onClick={closeMenu}>Media</Link>
                    <Link to="/shop" onClick={closeMenu}>Shop</Link>
                    <Link to="/support" onClick={closeMenu}>Support</Link>
                    <Link to="/champions" onClick={closeMenu}>
                        Wall of Champions
                    </Link>
                    <a
                        href="https://discord.gg/sZaRekrxha"
                        className="discord-button"
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={closeMenu}
                    >
                        Discord
                    </a>
                </div>

                <div className="account-nav">
                    <Link
                        to="/register"
                        className="register-button"
                        onClick={closeMenu}
                    >
                        Register
                    </Link>
                    <Link to="/login" onClick={closeMenu}>Log in</Link>
                </div>
            </div>
        </nav>
    );
};

export default MainNavbar;
